<template>
  <vue-modal :active="active" type="medium" @closed="$emit('closed')">
    <div class="flex justify-between items-center border-b border-gray-lighter mb-4">
      <h2 class="mb-2" v-text="title"></h2>
      <vue-tag class="mb-2" icon="vintage-wall-clock-solid">{{ createdAt }}</vue-tag>
    </div>
    <slot></slot>
    <div class="flex w-full justify-end flex-col-reverse md:flex-row border-t border-gray-lighter mt-4 pt-2">
      <vue-button @click="$modal.close()" class="btn btn-gray btn-outline w-full md:w-auto md:mr-2">Fermer</vue-button>
      <slot name="actions"></slot>
    </div>
  </vue-modal>
</template>

<script>
/* globals moment */
import modal from '../../mixins/modal';

export default {
  mixins: [modal],

  props: {
    title: {
      type: String,
      required: true,
    },
  },

  computed: {
    createdAt() {
      return moment(this.$parent.data.created_at).fromNow();
    },
  },
};
</script>
